import styles from './CreateChannelAttributeGroupFlow.module.scss';
import { Typography } from '@weareopenr/component-library';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

export const StepHeader = ({ title, subTitle }: { title: string; subTitle?: string }) => (
  <>
    <Typography size="xxlarge" weight="semi-bold" className={subTitle && cx('title')}>
      {title}
    </Typography>
    {subTitle && (
      <Typography size="large" weight="semi-bold">
        {subTitle}
      </Typography>
    )}
  </>
);
